// TOUR-12 — Fulfillment inspection intake lifecycle (fill → review → work).

import type { FireflyTourArtifact } from "../tourTypes";

export const FULFILLMENT_INTAKE_TOUR_ID = "tour-fulfillment-intake";

export const FULFILLMENT_INTAKE_TOUR: FireflyTourArtifact = {
  id: FULFILLMENT_INTAKE_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "inspection intake tour",
    "inspection intake",
    "start intake form",
    "approve intake",
    "intake form queue",
    "how do i fill an intake form",
    "fulfillment intake walkthrough",
  ],
  bucketRelevance: ["fulfillment"],
  requiredRoles: ["sales"],
  requiredCapabilities: ["hasSalesFloor"],
  steps: [
    {
      id: "nav-intake",
      target: {
        mode: "fulfillmentIntake",
        anchorId: "mode-nav-fulfillmentIntake",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "fulfillmentIntake",
      copy: {
        title: "Open Intake forms",
        body: "The three-tier inspection queue lives here — mandatory Tier 1 checks, optional Tier 2 upgrades, and Tier 3 free-form notes. Tap Intake forms in the Fulfillment bucket.",
      },
      waitForClick: true,
    },
    {
      id: "intake-queue",
      target: { mode: "fulfillmentIntake", anchorId: "ff-intake-queue", scrollIntoView: true },
      copy: {
        title: "Intake queue",
        body: "Forms progress through Needs filling → Needs review → Needs work → Approved. Each unit spawned from New inventory with a template lands in Needs filling first.",
      },
      advanceOn: "next_button",
    },
    {
      id: "needs-filling",
      target: {
        mode: "fulfillmentIntake",
        anchorId: "ff-intake-needs-filling",
        scrollIntoView: true,
      },
      copy: {
        title: "Needs filling",
        body: "Lot workers complete Tier 1 (Pass/N/A), Tier 2 upgrade elections, and Tier 3 suggestions here. Every Tier 1 item must be answered before submit.",
      },
      advanceOn: "next_button",
    },
    {
      id: "fill-action",
      target: { mode: "fulfillmentIntake", anchorId: "ff-intake-fill", scrollIntoView: true },
      copy: {
        title: "Fill intake form",
        body: "Tap Fill on a pending row to open the modal. Submit for review advances the form to the admin queue — Save draft keeps it pending.",
      },
      destructive: true,
    },
    {
      id: "needs-review",
      target: {
        mode: "fulfillmentIntake",
        anchorId: "ff-intake-needs-review",
        scrollIntoView: true,
      },
      copy: {
        title: "Needs review",
        body: "Admins and owners review submitted Tier 1/2 responses. Approve clears the unit for inventory, or Send to work when Tier 2 upgrades need shop time.",
      },
      advanceOn: "next_button",
    },
    {
      id: "review-action",
      target: { mode: "fulfillmentIntake", anchorId: "ff-intake-review", scrollIntoView: true },
      copy: {
        title: "Review / approve",
        body: "Tap Review on a row awaiting approval. Approve or Send to work — only admin/owner roles see this action.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "fulfillmentIntake", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Org custom forms (non-intake paperwork) live under Fulfillment → Forms. Ask Firefly anytime for inventory entry or Sales-mode tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
